var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 3.74A3.58 3.58 0 0022.52 2L6.68 24.09a3.6 3.6 0 001.98 5.58l9.01 2.42 1.34 13.17A3.58 3.58 0 0025.47 47l15.85-22.09a3.6 3.6 0 00-1.98-5.58l-9.01-2.42-1.34-13.17z",
    fill: "#FBE56D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97 27.7a.94.94 0 01-.13-1.76l6.57-2.8a.94.94 0 011.3.8l.32 4.65a.94.94 0 01-1.18.97l-6.88-1.85z",
    fill: "#F7C100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.13 22.43a.94.94 0 01.13 1.77L31.69 27a.94.94 0 01-1.3-.8l-.33-4.66a.94.94 0 011.18-.97l6.9 1.86z",
    fill: "#FFEF8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h48v48H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.04ed69bec412fc0c99c55ea0ea99e277.svg";
export { ForwardRef as ReactComponent };